// extracted by mini-css-extract-plugin
export var legendIndicator = "_co-1";
export var legendRight = "_co-0";